/**判断空字符
 * @val retrun Boolean
 *
*/
function isEmpty(val) {
	if(typeof val == 'undefined' || val == null || val == '') {
		return true;
	} else {
		return false;
	}
}
/**数组去重
 * @arr retrun array
 *
*/
function unique(arr) {
	var result = [],
		isRepeated;
	for(var i = 0, len = arr.length; i < len; i++) {
		isRepeated = false;
		for(var j = 0, len = result.length; j < len; j++) {
			if(arr[i] == result[j]) {
				isRepeated = true;
				break;
			}
		}
		if(!isRepeated) {
			result.push(arr[i]);
		}
	}
	return result;
}
/************************************************************************
|    函数名称： setCookie                                                |
|    函数功能： 设置cookie函数                                            |
|    入口参数： Name：cookie名称                                            |
|    维护记录： Spark(创建）     默认七天                                   |
*************************************************************************/
/* function setCookie(name, value)
{
    var argv = setCookie.arguments;
    var argc = setCookie.arguments.length;
    var expires = (argc > 2) ? argv[2] : 7;
    if(expires!=null)
    {
        var LargeExpDate = new Date ();
        LargeExpDate.setTime(LargeExpDate.getTime() + (expires*1000*3600*24));
    }
    document.cookie = name + "=" + escape (value)+((expires == null) ? "" : ("; expires=" +LargeExpDate.toGMTString()));
} */
function setCookie(name, value) 
{ 
    var Days = 7; 
    var exp = new Date(); 
    exp.setTime(exp.getTime() + Days*24*60*60*1000); 
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString(); 
}
/************************************************************************
|    函数名称： getCookie                                                |
|    函数功能： 读取cookie函数                                            |
|    入口参数： Name：cookie名称                                            |
|    维护记录： Spark(创建）         默认七天                                 |
*************************************************************************/
function getCookie(Name)
{
    var offset = null, end = null;
    var search = Name + "="
    if(document.cookie.length > 0)
    {
        offset = document.cookie.indexOf(search)
        if(offset != -1)
        {
            offset += search.length
            end = document.cookie.indexOf(";", offset)
            if(end == -1) end = document.cookie.length
            return unescape(document.cookie.substring(offset, end))
        }
        else return ""
    }
}
/**
 * 创建并下载文件
 * @param  {String} fileName 文件名
 * @param  {String} content  文件内容
 */
function createAndDownloadFile(fileName, content) {
    let aElement = document.createElement('a');
    aElement.download = fileName;
    document.body.appendChild(aElement); // 修复firefox中无法触发click
    if(typeof content === 'string') {
        aElement.href = content;
    } else {
        let blob = new Blob([content]);
        aElement.href = URL.createObjectURL(blob);
        URL.revokeObjectURL(blob);
    }
    aElement.click();
    document.body.removeChild(aElement);
}
window.isEmpty = isEmpty;
window.unique = unique;
window.setCookie = setCookie;
window.getCookie = getCookie;
window.createAndDownloadFile = createAndDownloadFile;